import moment from 'moment'

export const ProjectSearch = [
  {
    label: '运营项目名称',
    name: 'projectName',
    type:'input',
    prop:{
      placeholder: '请输入运营项目名称',
    },
  },
  {
    label: '合同项目编码',
    name: 'contractProjectCode',
    type:'input',
    prop:{
      placeholder: '请输入合同项目编码',
    },
  },
]

export const BusinessTypeOption = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '干',
    value: '干'
  },
  {
    label: '仓配一体',
    value: '仓配一体'
  },
  {
    label: '仓储',
    value: '仓储'
  },
  {
    label: '服务',
    value: '服务'
  },
  {
    label: '运输',
    value: '运输'
  },
  {
    label: '结算',
    value: '结算'
  },
  {
    label: '配',
    value: '配'
  }
]


export const SigningTypeOption = [
  {
    label: '直签',
    value: 'STRAIGHT_TO_SIGN'
  },
  {
    label: '甲方指定/直管',
    value: 'STRAIGHT_PIPE'
  },
  {
    label: '二手业务',
    value: 'SECOND_HAND_BUSINESS'
  },
  {
    label: '内部承接',
    value: 'INTERNAL_TO_UNDERTAKE'
  },
]

export const ContarctSearch = [
  {
    label: '合同项目名称',
    name: 'name',
    type:'input',
    prop:{
      placeholder: '请输入合同项目名称',
    },
  },
  {
    label: '合同项目编码',
    name: 'code',
    type:'input',
    prop:{
      placeholder: '请输入合同项目编码',
    },
  },
  {
    label: '服务品牌',
    name: 'brand',
    type:'input',
    prop:{
      placeholder: '请输入服务品牌',
    },
  },
  {
    label: '项目类型',
    name: 'businessType',
    type:'select',
    prop:{
      options: BusinessTypeOption
    },
  }
]

export const ProjectSigningType = {
  STRAIGHT_TO_SIGN: '直签',
  STRAIGHT_PIPE: '甲方指定/直管',
  SECOND_HAND_BUSINESS: '二手业务',
  INTERNAL_TO_UNDERTAKE: '内部承接'
}

export const ContarctTable = [
  {
    title: "序号",
    key: 'index',
    dataIndex: 'index',
    customRender: (text,row,index) => index+1,
    width: 80,
  },
  {
    title: "合同项目编码",
    dataIndex: "code",
    key: "code",
    width: 200,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "合同项目名称",
    dataIndex: "name",
    key: "name",
    width: 260,
    scopedSlots: { customRender: "name" },
  },
  {
    title: "服务品牌",
    dataIndex: "brand",
    key: "brand",
    width: 200,
    customRender: (text) => text || '--',
  },
  {
    title: "项目类型",
    dataIndex: "businessType",
    key: "businessType",
    width: 120,
  },
  {
    title: "签约类型",
    dataIndex: "projectSigningType",
    key: "projectSigningType",
    width: 140,
    customRender: text => ProjectSigningType[text] || '--'
  },
  {
    title: "创建人",
    dataIndex: "createUserName",
    key: "createUserName",
    width: 200,
  },
  {
    title: "项目开始时间",
    dataIndex: "termValidityStart",
    key: "termValidityStart",
    width: 140,
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : '--',
  },
  {
    title: "项目结束时间",
    dataIndex: "termValidityEnd",
    key: "termValidityEnd",
    width: 140,
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD') : '--',
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
    width: 180,
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '--',
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    fixed:'right',
    width: 140,
    scopedSlots: { customRender: "action" },
  },
]

// 品牌类型
export const BrandType = {
  NATIONWIDE: '全国品牌',
  DISTRICT: '区域型品牌'
}

export const CreateTypeList = [
  {
    value: 'INTERFACE',
    label: '接口下单'
  }
]